
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { ConfigModule } from '@/store/modules/config'
import { CONFIGAPI } from '@/api/config'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'editDialog',
  components: {}
})
export default class extends Vue {
  @Prop({ default: 'edit' }) private type!: string
  @Prop({ default: () => { return {} } }) private node!: any
  private options=[{
    value: 1,
    label: '网络需求类型'
  }, {
    value: 2,
    label: '运维事务类型'
  }, {
    value: 3,
    label: '网络变更类型'
  }, {
    value: 4,
    label: '网络变更涉及设备'
  }]

  private isDisableSubmit = false
  private formData = {
    id: 0,
    name: '',
    type_name: ''
  }

  private rules = {
    name: [
      { required: true, message: '请输入地区名称', trigger: 'blur' }
    ]
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    return ConfigModule.commonTypeAddDialog
  }

  @Watch('dialogVisible')
  private initForm() {
    if (this.dialogVisible) { // 打开弹框
      if (this.type === 'add' && this.node) {
        this.formData = {
          id: 0,
          name: '',
          type_name: ''
        }
      } else if (this.type === 'edit') {
        this.formData = Object.assign({}, this.node)
      }
    }
  }

  // 提交按钮触发
  private handleSubmit(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.isDisableSubmit = true
        if (this.type === 'add') {
          this.addRequest()
        } else {
          this.editRequest()
        }
      } else {
        return false
      }
    })
  }

  // 新建保存
  private addRequest() {
    CONFIGAPI.addCommonType({
      name: this.formData.name,
      type_name: this.formData.type_name
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'commonTypeAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 编辑保存
  private editRequest() {
    CONFIGAPI.editCommonType({
      name: this.formData.name,
      id: this.formData.id,
      type_name: this.formData.type_name
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'commonTypeAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 关闭弹框
  private handleClose() {
    ConfigModule.ToggleDialogStatus({
      name: 'commonTypeAddDialog',
      value: false
    })
  }
}
